module.exports = __webpack_public_path__ + "images/index/img05-5.e87dc71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/kua/img05-5.jpg
// module id = i9ib
// module chunks = 21